var exhIntersections1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections1.jpg';
var exhIntersections2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections2.jpg';
var exhIntersections3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections3.jpg';
var exhIntersections4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections4.jpg';
var exhIntersections5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections5.jpg';
var exhIntersections6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections6.jpg';
var exhIntersections7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections7.jpg';
var exhIntersections8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections8.jpg';
var exhIntersections9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections9.jpg';
var exhIntersections10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections10.jpg';
var exhIntersections11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections11.jpg';
var exhIntersections12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections12.jpg';
var exhIntersections13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-intersections/exhIntersections13.jpg';

export const allImagesDesktopOrderExhIntersections = [
    [/*COLUMN 1*/
        [
            {
                name: exhIntersections1,
                captionln1: "The title wall at Allan Stone Gallery during the solo exhibition, <b>Intersections</b>, in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections1"
            },
        ],
        [
            {
                name: exhIntersections2,
                captionln1: "The catalogue for the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections2"
            },
        ],
        [
            {
                name: exhIntersections3,
                captionln1: "The interior of the <b>Intersections</b> catalogue for the solo show at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections3"
            },
        ],
        [
            {
                name: exhIntersections5,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections5"
            },
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhIntersections4,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery.",
                captionln2: "",
                captionln3: "",
                link: "intersections4"
            },
        ],
        [
            {
                name: exhIntersections7,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections7"
            },
        ],
        [
            {
                name: exhIntersections8,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections8"
            },
        ],
        [
            {
                name: exhIntersections9,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections9"
            },
        ],
        [
            {
                name: exhIntersections6,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections6"
            },
        ],
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhIntersections10,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections10"
            },
        ],
        [
            {
                name: exhIntersections11,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections11"
            },
        ],
        [
            {
                name: exhIntersections12,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections12"
            },
        ],
        [
            {
                name: exhIntersections13,
                captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
                captionln2: "",
                captionln3: "",
                link: "intersections13"
            },
        ]
    ]          
]

export const allImagesMobileOrderExhIntersections = [
    [{
        name: exhIntersections1,
        captionln1: "The title wall at Allan Stone Gallery during the solo exhibition, <b>Intersections</b>, in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections1"
    },
    {
        name: exhIntersections2,
        captionln1: "The catalogue for the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections2"
    },
    {
        name: exhIntersections3,
        captionln1: "The interior of the <b>Intersections</b> catalogue for the solo show at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections3"
    },
    {
        name: exhIntersections4,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections4"
    },
    {
        name: exhIntersections5,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections5"
    },
    {
        name: exhIntersections6,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections6"
    },
    {
        name: exhIntersections7,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections7"
    },
    {
        name: exhIntersections8,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections8"
    },
    {
        name: exhIntersections9,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections9"
    },
    {
        name: exhIntersections10,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections10"
    },
    {
        name: exhIntersections11,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections11"
    },
    {
        name: exhIntersections12,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections12"
    },
    {
        name: exhIntersections13,
        captionln1: "The opening of the solo exhibition, <b>Intersections</b>, at Allan Stone Gallery in New York City.",
        captionln2: "",
        captionln3: "",
        link: "intersections13"
    }]      
]
